module.exports = require("./../../_gen/starling/animation/BezierEasing");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/animation/BezierEasing.js
// module id = 98
// module chunks = 0